import * as React from 'react';
import Card from '@mui/material/Card';
import { CardCustomFrom } from './CardItemClass';
import { Divider, Grid } from '@mui/material';


const CardFrom: React.FC<CardCustomFrom> = ({
  children, bgColor = "#fafdff", widthCard, heightCard, minHeightCard, footer
}) => {
  return (
    <Card sx={{
      display: "flex",
      flexDirection: "column",
      padding: "0.5rem",
      borderRadius: "20px !important",
      boxShadow: "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px !important",
      WebkitBackdropFilter: " blur(10px)",
      backdropFilter: "blur(10px)",
      background: "inherit",
      backgroundColor: bgColor,
      width: widthCard,
      height: heightCard,
      minHeight: minHeightCard,
    }}
    >
      {children}
      <Grid item padding={"5px"}></Grid>
      {footer &&
        <>
          <Grid item padding={"5px"}></Grid>
          <Divider />
          <Grid item padding={"5px"}></Grid>
          {footer}
        </>
      }
    </Card>
  );
}

export default CardFrom
